import {useTranslation} from '@/translations/i18n.tsx'
import {ErrorBox} from '@components/commons/error-box'
import {AlertTriangleIcon} from '@components/ui/icon'
import {ButtonLink} from '@components/commons/button-link'

export const RouteErrorElement = () => {
    const {t} = useTranslation()

    return (
        <ErrorBox
            icon={<AlertTriangleIcon />}
            title={t('errors:default')}
            cta={<ButtonLink to="/">{t('commons:go_home')}</ButtonLink>}
        />
    )
}
